"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidEmail = void 0;
require("core-js/modules/es.regexp.constructor.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
const isValidEmail = email => {
  const emailRegexString = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const emailAddressRegex = new RegExp(emailRegexString);
  return emailAddressRegex.test(email);
};
exports.isValidEmail = isValidEmail;